import { useEffect } from "react";

const Home = () => {
  return <div>Please use the Select box on the top right corner</div>;
};

export default Home;
